export interface RRIFileType {
  id: number;
  name: string;
  reviewEnabled?: boolean;
}
